import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrim]'
})
export class TrimDirective {
  private control: NgControl;
  inputElement: HTMLElement;
  constructor(public el: ElementRef, injector: Injector) {
    this.inputElement = el.nativeElement;
    //this make sure that not error if not applied to a NgControl
    try {
      this.control = injector.get(NgControl)
    }
    catch (e) {
    }
  }

  @HostListener("blur", ['$event'])
  onBlur(event: any) {

    let item = event.target;
    let value = item.value;
    if (value !== null && value !== "") {
      value = value.trim();
      // this.el.nativeElement.value = value;
     
        this.control.control == null?'': this.control.control.setValue(value);
      
    } else {
      return;
    }
  }
  @HostListener("paste", ['$event'])
  onPaste(event: any) {

    let item = event.target;
    let value = item.value;
    if (value !== null && value !== "") {
      //  value = value.trim();
      // this.el.nativeElement.value = value;
      this.control.control == null ? '' : this.control.control.setValue(value);
    } else {
      return;
    }
  }
}
